import { usePersonQuery, Person } from "@/features/people/graphql/generated";
import { useMemo } from "react";
import { useUpsertPerson } from "./useUpsertPerson";

const usePerson = (personId: number) => {
  const { data, loading, error } = usePersonQuery({
    variables: {
      personId,
    },
  });

  const person = useMemo(() => data?.person || ({} as Person), [data]);

  const { handleUpsertPerson, loading: updatingPerson } = useUpsertPerson(
    person.id!
  );

  return {
    person,
    loading,
    error,
    handleUpsertPerson,
    updatingPerson,
  };
};

export default usePerson;
